import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessageBoxOptions } from '@base/classes/BaseClasses';
import { ScreenService } from '@core/framework/screen.service';
import { EnumMenuPositions } from '@core/framework/sysenums.enum';
import { UiService } from '@core/framework/ui.service';
import { SysEventsService } from '@m4u-angular/core/framework/sysevents.service';
import { MessageBoxDialogComponent } from '@m4u-angular/ui/dialogs/messagebox-dialog/messageboxdialog.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'm4u-mainlayout',
    templateUrl: './mainlayout.component.html',
    styleUrls: ['./mainlayout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
    @ViewChild('messageBox') messageBoxDialog: MessageBoxDialogComponent;

    MenuOpened = false;
    private _subscriptions: Subscription[] = [];

    constructor(public screen: ScreenService,
        private events: SysEventsService,
        private ui: UiService) {
        this._subscriptions.push(this.events.OpenMessageBoxSubject.subscribe((options: MessageBoxOptions) => {
            this.OpenMessageBoxDialog(options);
        }));
    }

    ngOnInit() {
        this._subscriptions.push(this.events.MenuPositon.subscribe(p => this.SetMenuPositon(p)));
    }

    SetMenuPositon(position?: EnumMenuPositions) {
        if (!position) {
            this.MenuOpened = !this.MenuOpened;
            this.events.SetMenuPositon(this.MenuOpened ? EnumMenuPositions.Open : EnumMenuPositions.Close);
        } else {
            this.MenuOpened = position === EnumMenuPositions.Open;
        }
    }

    OpenMessageBoxDialog(options: MessageBoxOptions) {
        this.messageBoxDialog.Type = options.Type;
        this.messageBoxDialog.Prompt = options.Prompt;
        this.messageBoxDialog.ShowDialogShort(() => { 
            this.ui.CloseMessageBox(true); 
        }, () => { 
            this.ui.CloseMessageBox(false); 
        });
    }

    ngOnDestroy() {
        this._subscriptions.forEach(x => x.unsubscribe());
    }
}
